import { MouseEvent, useState } from 'react'
import type { FlatKeysInformProps, Step3FormProps } from '../types'

export const useStep3FlatKeysInform = (form: Step3FormProps['form']): FlatKeysInformProps => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [isUserInformed, setIsUserInformed] = useState(false)
    const handoverKeys = form.watch('handoverKeys')

    const handleUserInform = (e: MouseEvent<HTMLButtonElement>) => {
        e.preventDefault()
        if (handoverKeys === 'NotHandoverKeys') setIsUserInformed(true)
    }

    return { isUserInformed, handleUserInform }
}
